import { render, staticRenderFns } from "./WordFormComponent.vue?vue&type=template&id=5d187f72&"
import script from "./WordFormComponent.vue?vue&type=script&lang=js&"
export * from "./WordFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./WordFormComponent.vue?vue&type=style&index=0&id=5d187f72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports